"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * @hidden
 */
exports.numericIncreaseValue = 'numerictextbox.increment';
/**
 * @hidden
 */
exports.numericDecreaseValue = 'numerictextbox.decrement';
/**
 * @hidden
 */
exports.sliderIncreaseValue = 'slider.increment';
/**
 * @hidden
 */
exports.sliderDecreaseValue = 'slider.decrement';
/**
 * @hidden
 */
exports.sliderDragTitle = 'slider.dragTitle';
/**
 * @hidden
 */
exports.colorGradientR = 'colorGradient.r';
/**
 * @hidden
 */
exports.colorGradientG = 'colorGradient.g';
/**
 * @hidden
 */
exports.colorGradientB = 'colorGradient.b';
/**
 * @hidden
 */
exports.colorGradientA = 'colorGradient.a';
/**
 * @hidden
 */
exports.colorGradientHex = 'colorGradient.hex';
/**
 * @hidden
 */
exports.checkboxValidation = 'checkbox.validation';
/**
 * @hidden
 */
exports.checkboxOptionalText = 'checkbox.optionalText';
/**
 * @hidden
 */
exports.radioButtonValidation = 'radioButton.validation';
/**
 * @hidden
 */
exports.switchValidation = 'switch.validation';
/**
 * @hidden
 */
exports.messages = (_a = {},
    _a[exports.numericIncreaseValue] = 'Increase value',
    _a[exports.numericDecreaseValue] = 'Decrease value',
    _a[exports.sliderIncreaseValue] = 'Increase',
    _a[exports.sliderDecreaseValue] = 'Decrease',
    _a[exports.sliderDragTitle] = 'Drag',
    _a[exports.colorGradientR] = 'r',
    _a[exports.colorGradientG] = 'g',
    _a[exports.colorGradientB] = 'b',
    _a[exports.colorGradientA] = 'a',
    _a[exports.colorGradientHex] = 'hex',
    _a[exports.checkboxValidation] = 'Please check this box if you want to proceed!',
    _a[exports.checkboxOptionalText] = '(Optional)',
    _a[exports.radioButtonValidation] = 'Please select option if you want to proceed!',
    _a[exports.switchValidation] = 'Please turn on if you want to proceed!',
    _a);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-inputs@3.18.0_@progress+kendo-drawing@1.21.2_@progress+kendo-react-anim_73gurhvqk4avqqnlz5vbps7pya/~/@progress/kendo-react-inputs/dist/npm/messages/index.js
// module id = 80
// module chunks = 0